import { css, CSSResult } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { csColorBackground } from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { SCREENS } from '@cloudsuite/mosaic-shared/styles/breakpoints.js'


export const cscLightboxModal = {
  gap: css`var(--csc-lightbox-modal-gap, ${csSpacing.spacing08})`,
}

export const style: CSSResult = css`
  :host {
    display: block;
  }

  :host([hidden]) {
    display: none;
  }

  cse-modal {
    --cse-modal-large-width: 100%;
    --cse-modal-height: 100%;

    --cse-modal-header-background-color: ${csColorBackground.primary};

    
    --cse-modal-body-gap: var(--cs-spacing-08);
    --cse-modal-body-padding-x: var(--cs-spacing-08);
    --cse-modal-body-padding-y: var(--cs-spacing-08);

  }

  cse-modal .size-large {
    --cse-modal-large-width: 50%;
  }

  cse-modal.mobile {
    --cse-modal-width: 100%;
    --cse-modal-large-width: 100%;
    --cse-modal-height: 100vh;
    --cse-modal-height: 100dvh;
  }

  cse-modal.mobile .lightbox-modal-content {
    flex: 1;
    justify-content: center;
  }

  .mobile-footer {
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing08};
    width: 100%;
  }

  .mobile-footer .nav-controls {
    position: static;
    height: auto;
    width: 100%;
    padding: 0;
  }

  .lightbox-modal-content {
    display: flex;
    flex-direction: column;
    gap: ${cscLightboxModal.gap};
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    min-height: 0;
    position: relative;
  }

  .image-navigation-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 0;
  }

  .image-container {
    width: 100%;
    aspect-ratio: 4 / 3;
    max-height: 70vh;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    position: relative;
  }

  .image-container.is-video {
    aspect-ratio: 16 / 9;
    max-width: calc(70vh * 16 / 9);
    margin: 0 auto;
  }

  .image-container csc-lightbox-media {
    width: 100%;
    height: 100%;
    display: block;
    position: absolute;
    inset: 0;
  }

  .image-enter {
    animation: slideIn 0.35s ease-out forwards;
  }

  .image-exit {
    animation: slideOut 0.35s ease-out forwards;
  }

  .slide-left .image-enter {
    animation-name: slideInFromRight;
  }

  .slide-left .image-exit {
    animation-name: slideOutToLeft;
  }

  .slide-right .image-enter {
    animation-name: slideInFromLeft;
  }

  .slide-right .image-exit {
    animation-name: slideOutToRight;
  }

  @keyframes slideInFromRight {
    from { transform: translateX(100%); opacity: 0; }
    to { transform: translateX(0); opacity: 1; }
  }

  @keyframes slideOutToLeft {
    from { transform: translateX(0); opacity: 1; }
    to { transform: translateX(-100%); opacity: 0; }
  }

  @keyframes slideInFromLeft {
    from { transform: translateX(-100%); opacity: 0; }
    to { transform: translateX(0); opacity: 1; }
  }

  @keyframes slideOutToRight {
    from { transform: translateX(0); opacity: 1; }
    to { transform: translateX(100%); opacity: 0; }
  }

  .modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }

  .nav-controls {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 ${csSpacing.spacing05};
    pointer-events: none;
    z-index: 2;
    box-sizing: border-box;
  }

  .nav-controls cse-icon-button {
    pointer-events: auto;
  }

  .lightbox-modal-content csc-lightbox-thumbnails {
    width: 100%;
  }

  @media (max-width: ${SCREENS.small}) {
    cse-modal {
      --cse-modal-width: 100vw;
    }

    .lightbox-modal-content {
      gap: ${csSpacing.spacing10};
      overflow: hidden;
    }

    .image-navigation-wrapper {
      flex: 1;
      flex-direction: column;
      min-height: 0;
    }

    .image-container {
      aspect-ratio: auto;
      height: 100%;
      max-height: 100%;
      min-height: 0;
      flex: 1;
    }

    .image-container.is-video {
      aspect-ratio: auto;
      max-width: 100%;
    }

    .nav-controls {
      position: static;
      height: auto;
      width: 100%;
      padding: 0 ${csSpacing.spacing05};
    }
  }
`
